import mainLogo from "./main-logo.svg";
import msgIcon from "./msg-icon.svg";
import googleIcon from "./google-icon.svg";
import signupSlider1 from "./signup-1.svg";
import signupSlider2 from "./signup-2.svg";
import signupSlider3 from "./signup-3.svg";
import signupSlider4 from "./signup-4.svg";
import closeIcon from "./close-icon.svg";
import closeIconRed from "./close-icon-red.svg";
import searchIcon from "./search-small-icon.svg";
import defaultProfileImage from "./default-user.png";
import RefreshIcon from "./refresh-icon.svg";
import removeUserIcon from "./remove-user-icon.svg";
import removeUserIcon2 from "./remove-user-icon-2.svg";
import leaveFeteIcon from "./leave-fete-icon.svg";
import leaveTeamIcon from "./leave-team-icon.svg";
import RemoveUserIcon3 from "./remove-user-icon1.svg";
import transferIcon from "./transfer-owership-icon.svg";
import backArrow from "./back-arrow.svg";
import arrowRightGrey from "./arrow-grey.svg";
import arrowRightBlue from "./arrow-blue.svg";
import arrowRightWhite from "./arrow-white-right.svg";
import defaultTeamProfileImage from './team-profile-default-icon.png';
import verifyBannerUpdated from "./verify-banner-updated.svg";
import miceIcon from "./mice-icon.svg";
import circularPatternlg from "./circular-pattern-lg.svg";
import fileTypeIcon from "./file-type-icon-new.svg";
import plusIcon from "./plus-icon.svg";
import dummyImg from "./fete-img-1.png";
import outsideIcon from "./outside-arrow-icon.svg";
import featuredIcon from './featured-icon.svg';
import avatar from './avatar.svg';
import addReminderDateBg from './add-reminder-date-with-bg.svg';
import dummyImg1 from "./dummy-img-1.png";
import starIcon2 from "./star-icon-2.svg";
import plusIcon2 from "./plus-icon-2.svg";
import targetIcon from "./target-icon.svg";
import calenderIcon from "./callender-icon.svg";
import teamIcon2 from "./team-icon-2.svg";
import locationIcon from "./location-icon.svg";
import dollorIcon from "./dollor-icon.svg";
import defaultProfile from "./default-user.png";
import calenderCheckCardIcon from './calendar-check-card-icon.svg';
import bellDotCardIcon from './bell-dot-card-icon.svg';
import blankImg from './blank-img.svg';
import pushPinIcon from './push-pin.svg';
import editChatIcon from './edit-chatbox-icon.svg';
import fetebuddyGradientIcon from './fetebuddy-gradient-icon.svg';
import threeDotsHorizontalIcons from './three-dots-horizontal-icons.svg';
import toggleIcon from './toggle-icon.svg';
import rightCheckBlueIcon from './right-check-blue-icon.svg';
import backModalShade from './bg-modal-shade.svg';
import markcompleteIcon from './markcompleteIcon.svg';
import ToastGreenCheckIcon from './toast-check-green-icon.svg';
import RightCheckGreenIcon from './right-check-green-icon.svg';
import heartIconWhite from './heart-icon-white.svg';
import heartIconGrey from './heart-icon-grey.svg';
import heartIconRed from './heart-icon-red.svg';
import starLoaderIcon from './star-loader-icon.svg';
import feteGif from './Fetegif.gif';
import addMemberIcon from './modal-upload-icon.svg';
import featuredRoundShadeIcon from './featured-round-shade-icons.svg';
import removeUserIcon4 from './removeuser-icon.svg';
import uploadFileIcon from './upload-file-icon.svg';
import uploadFileIcon2 from './upload-icon.svg';
import uploadFileIcon3 from './file-upload-icon-2.svg';
import fileTypePdfIcon from './file-type-pdf-icon.svg';
import fileTypeDOCXIcon from './file-type-docx-icon.svg';
import fileTypeCSVIcon from './file-type-csv-icon.svg';
import fileTypeTXTIcon from './file-type-txt-icon.svg';
import fileTypeXLSXIcon from './file-type-xls-icon.svg';
import dragIcon from './drag-icon.svg';
import downArrowIcon1 from './down-arow-icon1.svg';
import downArrowIcon2 from './down-arrow-icon2.svg';
import plusIcon3 from './plus-icon-4.svg';
import downArrowIcon3 from './down-arrow-3.svg';
import feteTypeIcon from './fete-type-icon.svg';
import downArrowIcon4 from './down-icon4.svg';
import downArrowIcon5 from './down-icon5.svg';
import plusIcon5 from './plus-icon-5.svg';
import clockIcon from './clock-icon.svg';
import deleteIcon2 from './delete-icon2.svg';
import deleteIcon4 from './delete-icon4.svg';
import confettiIcon from './fete-icon.svg';
import outSideArrayIcon from './outside-arrow-grey-icon.svg';
import useProfileIcon from './user-square-icon.svg';
import plusIcon6 from './plus-icon-6.svg';
import plusIcon7 from './plus-icon-7.svg';
import settingsIcon from './settings-icon.svg';
import logOutIcon from './logout-icon.svg';
import upcomingFeteIcon from './upcoming-fete-icon.svg';
import rightCheckMarkIcon from './right-check-mark-grey.svg';
import draftIcon from './draft-icon.svg';
import upcomingDraftIcon from './upcoming-fete-draft.svg';
import successToastIcon from './toast-icons/success-icon.svg';
import errorToastIcon from './toast-icons/error-icon.svg';
import warningToastIcon from './toast-icons/warning-icon.svg';
import infoToastIcon from './toast-icons/info-icon.svg';
import customiseIcon from './customise-icon.svg';
import plusCircleIcon from './plus-circle-white-icon.svg';
import questionMarkIcon from './question-mark-icon.svg';
import threeVerticleDotsIcon from './three-dots-icon.svg';
import budgVenue from './budget-rollover/venue.svg';
import budgGuest from './budget-rollover/guest-speakers.svg';
import budgGifts from './budget-rollover/gift.svg';
import budgFood from './budget-rollover/food.svg';
import budgEntertaintment2 from './budget-rollover/entertaintment2.svg';
import budgEntertaintment from './budget-rollover/entertaintment.svg';
import budgAv from './budget-rollover/av.svg';
import assignedBudget from './assigned-budgt.svg';
import utilizedBudget from './utilized-budgt.svg';
import sponsoredBudget from './sponsored-budgt.svg';
import savedBudget from './saved-budgt.svg';
import trendUpIcon from './trend-up--icon.svg';
import customizeInsighIcon from './customize-insight-icon.svg';
import customizeInsighCountdown from './customize-insight/fete-countdown.svg';
import customizeInsighInvoive from './customize-insight/contract-invoice.svg';
import customizeInsighBudgetUtilization from './customize-insight/budget-utiliozation.svg';
import customizeInsighBudgetSplit from './customize-insight/budget-split.svg';
import customizeInsighBudgetRollover from './customize-insight/budget-rollover.svg';
import customizeInsighAttendee from './customize-insight/attendee-map.svg';
import EditIcon from './edit-icon.svg';
import EditIcon2 from './edit-icon2.svg';
import MoveIcon from './move-icon.svg';
import ResizeIcon from './resize-icon.svg';
import MaximizeIcon from './maximize-icon.svg';
import BarChartIcon from './bar-chart-icon.svg';
import LineChartIcon from './line-chart-icon.svg';
import PieChartIcon from './pie-chart-icon.svg';
import ActivityGuageChartIcon from './activity-gauge-icon.svg';
import ListChartIcon from './list-icon.svg';
import TableChartIcon from './table-icon.svg';
import EditTextIcon from './edit-text-icon.svg';
import budgetRollover from './budget-rollover.svg';
import downloadIcon from './download-icon.svg';
import downloadIcon2 from './download-icon2.svg';
import progressIcon from './progress-icon.svg';
import completedIcon from './completed-icon.svg';
import iButtonIcon from './iButton-icon.svg';
import deleteIcon5 from './delete-icon5.svg';
import plusIconBlack from './plus-circle-black-icon.svg';
import leftArrow from './chevron-left-icon.svg';
import rightArrow from './chevron-right-icon.svg';
import filterIcon from './filter-icons.svg';
import historyIcon from './history-icon.svg';
import historyDraft from './history/draft.svg';
import historyDate from './history/chnaged-date.svg';
import historyNewFate from './history/created-new-fete.svg';
import historyInvitation from './history/invitation.svg';
import historySelected from './history/selected.svg';
import historyUploaded from './history/uploaded-file.svg';
import pinPushIcon from './pin-icon2.svg';
import pinModalIcon3 from './pinit-icon3.svg';
import copyIcon from './copy-icon.svg';
import pinnedStateIcon from './pinned-state-icon.svg';
import unpinIcon from './unpin-icon.svg';
import reviewSpaceEmptyState from './empty-states/review-space-empty-state.svg';
import boardEmptyState from './empty-states/board-empty-state.svg';
import recentActivityEmptyState from './empty-states/recent-activity-empty-state.svg';
import upcoingFeteEmptyState from './empty-states/upcoing-fetes-empty-state.svg';
import pastFeteEmptyState from './empty-states/past-fete-empty-state.svg';
import historyEmptyState from './empty-states/history-empty-state.svg';
import historyFavoriteState from './empty-states/favorites-empty-state.svg';
import arrowRightIcon from './arrow-right-circle.svg';
import chatbarSuggestionOpenIcon from './chatbar-suggestion-icon.svg';
import chatbarSuggestionCloseIcon from './chatbar-suggestion-close-icon.svg';
import nextBlueIcon from './next-blue-icon.svg';
import brainstromIcon from './brainstom-icon.svg';
import reviewSelectedIcon from './review-selected-icon.svg';
import plusCircleBlueIcon from './plus-circle-blue-icon.svg';
import suggestionDraft from './searchbar-suggestion/draft-icon.svg';
import suggestionBrainStorm from './searchbar-suggestion/brainstrom-icon.svg';
import suggestionExplore from './searchbar-suggestion/explore-icon.svg';
import suggestionShowSaved from './searchbar-suggestion/show-saved-icon.svg';
import suggestionUpload from './searchbar-suggestion/upload-icon.svg';
import suggestionUploadInspiration from './searchbar-suggestion/upload-inspiration-icon.svg';
import suggestionView from './searchbar-suggestion/view-icon.svg';
import suggestionView2 from './searchbar-suggestion/view2-icon.svg';
import suggestionShowSaved2 from './searchbar-suggestion/show-saved.svg';
import suggestionShowFavorite from './searchbar-suggestion/show-favorite.svg';
import suggestionVenueInspired from './searchbar-suggestion/venue-inspired.svg';
import rightCheckWhiteIcon from './right-check-white-icon.svg';
import aiOption from './ai-option.svg';
import rfpFileLogo from './rfp-file-logo.svg';
import photoIcon from './image-icon.svg';
import facebookIcon from './facebook-icon.svg';
import xIcon from './x-icon.svg';
import linkedinIcon from './linkedin-icon.svg';
import instagramIcon from './instagram-icon.svg';
import EditIcon3 from './edit-icon3.svg';
import Pstate1 from './pstate/pstate-1.svg';
import Pstate2 from './pstate/pstate-2.svg';
import Pstate3 from './pstate/pstate-3.svg';
import Pstate4 from './pstate/pstate-4.svg';
import Pstate5 from './pstate/pstate-5.svg';
import Pstate6 from './pstate/pstate-6.svg';
import ContractPinned from "./contract_pinned.png";
import imageIcon from "./image-icon.svg";
import highLightIcon from "./highlights.svg";
import EmailTemplateImage from "./email_template.png";
import EventProgramImage from "./event_program.png";
import sendIcon from "./send-icon.svg";
import circleIcon from "./circle-icon.svg";
import sortIcon from "./sort-icon.svg";
import sendIcon4 from "./send-icon4.svg";
import fbIcon from "./fb-icon.svg";
import decoreIcon from "./decore-icon.svg";
import pagiRightBtn from "./pagi-right-but.svg";
import pagiLeftBtn from "./pagi-left-but.svg";
import alertIconSaffron from "./alert-icon.svg";
import noImage from "./no-image.png";
import fileUpload from "./file_upload.png";
import showAllImgIcon from "./show-all-img.svg";
import outLinkIcon from "./chat-box-link-icon.svg";
import selectedStateIcon from "./selected-state-icon.svg";
import feteIcon from "./feteIcon.svg";
import editIcon5 from "./edit-icon-5.svg";
import transferIcon4 from "./transferIcon-4.svg";
import removeuserIcon5 from "./removeusericon-4.svg";
import arrowUp3 from "./arrow-up-icon-3.svg";
import selectFileEmptyState from "./select-file-empty-state.png";
import logiConferenceRoom from "./logistics-spaces/conference-room-space.svg";
import logiClassRoom from "./logistics-spaces/classroom-space.svg";
import logiUshapeRoom from "./logistics-spaces/u-shape-space.svg";
import logiBanquet from "./logistics-spaces/banquet-space.svg";
import logiTheatre from "./logistics-spaces/theater-space.svg";
import logiHollowSpace from "./logistics-spaces/hollow-square-space.svg";
import logiCabret from "./logistics-spaces/cabaret-style-space.svg";
import logiInterview from "./logistics-spaces/interview-room-space.svg";
import logiBreakout from "./logistics-spaces/breakout-room-space.svg";
import logiHuddle from "./logistics-spaces/huddle-room-space.svg";
import logiCoworking from "./logistics-spaces/co-working-space-space.svg";
import logiWarroom from "./logistics-spaces/war-room-space.svg";
import crossIcon from "./cross-icon-5.svg";
import deleteIcon6 from "./delete-icon-6.svg";
import logisticsEmptyState from "./logistics-empty-state.svg";
import vendorLoginBanner from "./vendor/onboarding-banner.svg";
import vendorMessageIcon from "./vendor/message-icon.svg";
import vendorFileAttachmentIcon from "./vendor/file-attachment-icon.svg";
import vendorRightCheckIcon from "./vendor/right-check.svg";
import vendorWhiteIcon from "./vendor/feteboard-whiteboard-logo.svg";
import vendorRightArrowIcon from "./vendor/left-arrow.svg";
import vendorLeftArrowIcon from "./vendor/right-arrow.svg";
import vendorFacebookIcon from "./vendor/vfacebook.svg";
import vendorInstagramIcon from "./vendor/vinstagram.svg";
import vendorYoutubeIcon from "./vendor/vyoutube.svg";
import vendorLikedinIcon from "./vendor/vlinkedin.svg";
import vendorPinterestIcon from "./vendor/vpinterest.svg";
import vendorXIcon from "./vendor/vtwitter.svg";
import vendorLeftArrowBlueIcon from "./vendor/right-arrow-blue.svg";
import vendorAccomodationIcon from "./vendor/chips/vaccommodation.svg";
import vendorActivityIcon from "./vendor/chips/vaactivity.svg";
import vendorDecoreIcon from "./vendor/chips/vadecor.svg";
import vendorEntertaintmentIcon from "./vendor/chips/vaentertaintment.svg";
import vendorFoodIcon from "./vendor/chips/vafood-bevearge.svg";
import vendorGiftingIcon from "./vendor/chips/vagifting.svg";
import vendorMarketingIcon from "./vendor/chips/vamarketing.svg";
import vendorOthersIcon from "./vendor/chips/vaothers.svg";
import vendorSecurityIcon from "./vendor/chips/vasecurity.svg";
import vendorTechIcon from "./vendor/chips/vatech.svg";
import vendorTransportationIcon from "./vendor/chips/vatransportation.svg";
import vcAccomodation from "./vendor/category/accomodation.svg";
import vcActivity from "./vendor/category/activity.svg";
import vcDecore from "./vendor/category/decore.svg";
import vcEntertaintment from "./vendor/category/entertaintment.svg";
import vcEventVenue from "./vendor/category/event-venue.svg";
import vcFoodBeverage from "./vendor/category/food-beverage.svg";
import vcGifting from "./vendor/category/gifting.svg";
import vcMarketing from "./vendor/category/marketing.svg";
import vcTech from "./vendor/category/tech-partner.svg";
import vcTransportation from "./vendor/category/transporatation.svg";
import vcSecurity from "./vendor/category/security.svg";
import vcOthers from "./vendor/category/others.svg";

const allImgPaths = (() => ({
	vcSecurity,
	vcAccomodation,
	vcActivity,
	vcDecore,
	vcEntertaintment,
	vcEventVenue,
	vcFoodBeverage,
	vcGifting,
	vcMarketing,
	vcTech,
	vcTransportation,
	vcOthers,
	vendorAccomodationIcon,
	vendorActivityIcon,
	vendorDecoreIcon,
	vendorEntertaintmentIcon,
	vendorFoodIcon,
	vendorGiftingIcon,
	vendorMarketingIcon,
	vendorOthersIcon,
	vendorTechIcon,
	vendorTransportationIcon,
	vendorSecurityIcon,
	vendorFacebookIcon,
	vendorInstagramIcon,
	vendorYoutubeIcon,
	vendorLikedinIcon,
	vendorPinterestIcon,
	vendorXIcon,
	vendorLeftArrowBlueIcon,
	vendorLeftArrowIcon,
	vendorRightArrowIcon,
	vendorWhiteIcon,
	vendorRightCheckIcon,
	vendorFileAttachmentIcon,
	vendorMessageIcon,
	vendorLoginBanner,
	closeIcon,
	searchIcon,
	defaultProfileImage,
	RefreshIcon,
	removeUserIcon,
	removeUserIcon2,
	leaveFeteIcon,
	RemoveUserIcon3,
	transferIcon,
	mainLogo,
	msgIcon,
	googleIcon,
	signupSlider1,
	signupSlider2,
	signupSlider3,
	signupSlider4,
	backArrow,
	arrowRightGrey,
	arrowRightBlue,
	defaultTeamProfileImage,
	verifyBannerUpdated,
	miceIcon,
	circularPatternlg,
	fileTypeIcon,
	plusIcon,
	dummyImg,
	outsideIcon,
	featuredIcon,
	avatar,
	addReminderDateBg,
	dummyImg1,
	starIcon2,
	plusIcon2,
	plusIcon3,
	targetIcon,
	calenderIcon,
	teamIcon2,
	locationIcon,
	dollorIcon,
	defaultProfile,
	bellDotCardIcon,
	calenderCheckCardIcon,
	blankImg,
	pushPinIcon,
	editChatIcon,
	fetebuddyGradientIcon,
	threeDotsHorizontalIcons,
	toggleIcon,
	rightCheckBlueIcon,
	backModalShade,
	markcompleteIcon,
	ToastGreenCheckIcon,
	RightCheckGreenIcon,
	heartIconWhite,
	heartIconGrey,
	heartIconRed,
	starLoaderIcon,
	feteGif,
	closeIconRed,
	addMemberIcon,
	featuredRoundShadeIcon,
	leaveTeamIcon,
	removeUserIcon4,
	uploadFileIcon,
	uploadFileIcon2,
	uploadFileIcon3,
	fileTypePdfIcon,
	fileTypeDOCXIcon,
	fileTypeCSVIcon,
	fileTypeTXTIcon,
	fileTypeXLSXIcon,
	dragIcon,
	downArrowIcon1,
	downArrowIcon2,
	downArrowIcon3,
	downArrowIcon4,
	downArrowIcon5,
	feteTypeIcon,
	plusIcon5,
	clockIcon,
	deleteIcon2,
	deleteIcon4,
	confettiIcon,
	outSideArrayIcon,
	useProfileIcon,
	plusIcon6,
	settingsIcon,
	logOutIcon,
	upcomingFeteIcon,
	arrowRightWhite,
	rightCheckMarkIcon,
	draftIcon,
	upcomingDraftIcon,
	infoToastIcon,
	warningToastIcon,
	successToastIcon,
	errorToastIcon,
	customiseIcon,
	plusCircleIcon,
	questionMarkIcon,
	threeVerticleDotsIcon,
	budgVenue,
	budgGuest,
	budgGifts,
	budgFood,
	budgEntertaintment2,
	budgEntertaintment,
	budgAv,
	savedBudget,
	sponsoredBudget,
	utilizedBudget,
	assignedBudget,
	trendUpIcon,
	customizeInsighIcon,
	customizeInsighCountdown,
	customizeInsighInvoive,
	customizeInsighBudgetUtilization,
	customizeInsighBudgetSplit,
	customizeInsighBudgetRollover,
	customizeInsighAttendee,
	EditIcon,
	MaximizeIcon,
	ResizeIcon,
	MoveIcon,
	BarChartIcon,
	LineChartIcon,
	PieChartIcon,
	ActivityGuageChartIcon,
	ListChartIcon,
	TableChartIcon,
	EditTextIcon,
	budgetRollover,
	downloadIcon,
	downloadIcon2,
	completedIcon,
	progressIcon,
	iButtonIcon,
	EditIcon2,
	deleteIcon5,
	plusIconBlack,
	rightArrow,
	leftArrow,
	filterIcon,
	historyIcon,
	historyDraft,
	historyDate,
	historyNewFate,
	historyInvitation,
	historySelected,
	historyUploaded,
	pinPushIcon,
	pinModalIcon3,
	copyIcon,
	pinnedStateIcon,
	unpinIcon,
	reviewSpaceEmptyState,
	boardEmptyState,
	recentActivityEmptyState,
	upcoingFeteEmptyState,
	plusIcon7,
	pastFeteEmptyState,
	historyEmptyState,
	historyFavoriteState,
	arrowRightIcon,
	chatbarSuggestionOpenIcon,
	chatbarSuggestionCloseIcon,
	nextBlueIcon,
	brainstromIcon,
	reviewSelectedIcon,
	plusCircleBlueIcon,
	suggestionDraft,
	suggestionBrainStorm,
	suggestionExplore,
	suggestionShowSaved,
	suggestionUpload,
	suggestionUploadInspiration,
	suggestionView,
	suggestionView2,
	rightCheckWhiteIcon,
	aiOption,
	rfpFileLogo,
	photoIcon,
	facebookIcon,
	xIcon,
	linkedinIcon,
	instagramIcon,
	EditIcon3,
	Pstate1,
	Pstate2,
	Pstate3,
	Pstate4,
	Pstate5,
	Pstate6,
	ContractPinned,
	imageIcon,
	highLightIcon,
	EmailTemplateImage,
	EventProgramImage,
	sendIcon,
	circleIcon,
	sortIcon,
	sendIcon4,
	decoreIcon,
	fbIcon,
	pagiLeftBtn,
	pagiRightBtn,
	alertIconSaffron,
	noImage,
	fileUpload,
	showAllImgIcon,
	outLinkIcon,
	selectedStateIcon,
	feteIcon,
	editIcon5,
	removeuserIcon5,
	transferIcon4,
	arrowUp3,
	selectFileEmptyState,
	logiConferenceRoom,
	logiClassRoom,
	logiUshapeRoom,
	logiBanquet,
	logiTheatre,
	logiHollowSpace,
	logiCabret,
	logiInterview,
	logiBreakout,
	logiHuddle,
	logiCoworking,
	logiWarroom,
	suggestionShowSaved2,
	suggestionShowFavorite,
	suggestionVenueInspired,
	crossIcon,
	deleteIcon6,
	logisticsEmptyState

}))();
export default allImgPaths;
